// This table is a code representation of the table that defines min and max ages for Term products.
// Ideally the values should come from Product.ts

import { Product } from '../../../../common/js/static/Product';

/**
 * source: https://docs.google.com/spreadsheets/d/1ikiu_H0LeqfNR7dcMh2fpJ78KjSmo8b1KeW3eJFRGSA/edit#gid=0
 *
 * Q/ Table says 65 but UI Error message says 64
 * R/ Because Haven sells policy for people that one year younger than the required max,
 * this helps in avoiding problems that would occur if insurer applies at near 65 age, then policy issuing process (application filling, underwriting, signing ...)
 * finish when insurer is older than 65.
 */

// Coverpath Term Issue Ages

export enum FaceAmountLimit {
  UPTO_1M = 'UPTO_1M',
  UPTO_3M = 'UPTO_3M',
}

export const CPConvertibleTermAgeRanges = {
  '1': {
    [FaceAmountLimit.UPTO_1M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.termBreakdown[1].maxAge,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.termBreakdown[1].maxAge,
      },
    },
    [FaceAmountLimit.UPTO_3M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.maxAgeForHigherFace,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.maxAgeForHigherFace,
      },
    },
  },
  '10': {
    [FaceAmountLimit.UPTO_1M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.termBreakdown[10].maxAge,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.termBreakdown[10].maxAge,
      },
    },
    [FaceAmountLimit.UPTO_3M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.maxAgeForHigherFace,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.maxAgeForHigherFace,
      },
    },
  },
  '15': {
    [FaceAmountLimit.UPTO_1M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.termBreakdown[15].maxAge,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.termBreakdown[15].maxAge,
      },
    },
    [FaceAmountLimit.UPTO_3M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.maxAgeForHigherFace,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.maxAgeForHigherFace,
      },
    },
  },
  '20': {
    [FaceAmountLimit.UPTO_1M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.termBreakdown[20].maxAge,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.termBreakdown[20].maxAge,
      },
    },
    [FaceAmountLimit.UPTO_3M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.maxAgeForHigherFace,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.maxAgeForHigherFace,
      },
    },
  },
  '25': {
    [FaceAmountLimit.UPTO_1M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.termBreakdown[25].maxAge,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.termBreakdown[25].tobaccoMaxAge,
      },
    },
    [FaceAmountLimit.UPTO_3M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.maxAgeForHigherFace,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.termBreakdown[25].tobaccoMaxAge,
      },
    },
  },
  '30': {
    [FaceAmountLimit.UPTO_1M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.termBreakdown[30].maxAge,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.termBreakdown[30].tobaccoMaxAge,
      },
    },
    [FaceAmountLimit.UPTO_3M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.termBreakdown[30].maxAge,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTerm.minAge,
        maxAge: Product.productSpecs.CASTerm.termBreakdown[30].tobaccoMaxAge,
      },
    },
  },
  '15ECP': {
    [FaceAmountLimit.UPTO_1M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTermECP.minAge,
        maxAge: Product.productSpecs.CASTermECP.termBreakdown[15].maxAge,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTermECP.minAge,
        maxAge: Product.productSpecs.CASTermECP.termBreakdown[15].maxAge,
      },
    },
    [FaceAmountLimit.UPTO_3M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTermECP.minAge,
        maxAge: Product.productSpecs.CASTermECP.termBreakdown[15].maxAge,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTermECP.minAge,
        maxAge: Product.productSpecs.CASTermECP.termBreakdown[15].maxAge,
      },
    },
  },
  '20ECP': {
    [FaceAmountLimit.UPTO_1M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTermECP.minAge,
        maxAge: Product.productSpecs.CASTermECP.termBreakdown[20].maxAge,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTermECP.minAge,
        maxAge: Product.productSpecs.CASTermECP.termBreakdown[20].maxAge,
      },
    },
    [FaceAmountLimit.UPTO_3M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTermECP.minAge,
        maxAge: Product.productSpecs.CASTermECP.termBreakdown[20].maxAge,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTermECP.minAge,
        maxAge: Product.productSpecs.CASTermECP.termBreakdown[20].maxAge,
      },
    },
  },
  '25ECP': {
    [FaceAmountLimit.UPTO_1M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTermECP.minAge,
        maxAge: Product.productSpecs.CASTermECP.termBreakdown[25].maxAge,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTermECP.minAge,
        maxAge: Product.productSpecs.CASTermECP.termBreakdown[25].maxAge,
      },
    },
    [FaceAmountLimit.UPTO_3M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTermECP.minAge,
        maxAge: Product.productSpecs.CASTermECP.termBreakdown[25].maxAge,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTermECP.minAge,
        maxAge: Product.productSpecs.CASTermECP.termBreakdown[25].maxAge,
      },
    },
  },
  '30ECP': {
    [FaceAmountLimit.UPTO_1M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTermECP.minAge,
        maxAge: Product.productSpecs.CASTermECP.termBreakdown[30].maxAge,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTermECP.minAge,
        maxAge: Product.productSpecs.CASTermECP.termBreakdown[30].tobaccoMaxAge,
      },
    },
    [FaceAmountLimit.UPTO_3M]: {
      NON_TOBACCO: {
        minAge: Product.productSpecs.CASTermECP.minAge,
        maxAge: Product.productSpecs.CASTermECP.termBreakdown[30].maxAge,
      },
      TOBACCO: {
        minAge: Product.productSpecs.CASTermECP.minAge,
        maxAge: Product.productSpecs.CASTermECP.termBreakdown[30].tobaccoMaxAge,
      },
    },
  },
};
